export default __webpack_public_path__ + "static/media/gothenburg_l3.e0ace65c.png";